// swiper code

const swiper = new Swiper('.product-slider-swiper', {
    slidesPerView: '1',
    spaceBetween: 20,
    centeredSlides: true,
    initialSlide: 0,
    loop: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        769: {
            slidesPerView: 3,
        },
    },
    navigation: {
        nextEl: '.product-slider-button-next',
        prevEl: '.product-slider-button-prev',
    },

    pagination: {
        el: '.product-slider-pagination',
        clickable: true,
    },
});
